<!-- Enroll All modal -->

<ds-modal
  (onCloseModalEvent)="closeModal.emit(modalId)"
  [id]="modalId"
  [closeOthers]="true"
  [maxWidth]="496"
>
  <div class="row pad-horizontal-20">
    <div class="column twelve">
      <h3 class="text-center margin-bottom-20">Assign Phone Numbers</h3>
      <p class="margin-bottom-20">
        For each driver enrolled in KnowYourDrive, you’ll have to assign them a unique phone number
        associated with an Android or iOS device. This allows us to send a link to download
        KnowYourDrive.
      </p>
    </div>
    @if (!!operatorsData) {
      <table class="table table-striped fill lg-large">
        <tbody>
          @for (operator of operatorsData | keyvalue; track operator) {
            <tr>
              @if (operator.value.status !== 'Enrolled') {
                <td class="column sm-six">
                  {{ operator.value.fullName }}
                </td>
              }
              @if (operator.value.status !== 'Enrolled') {
                <td class="column sm-six">
                  <input
                    [value]=""
                    [identifier]="'phone' + operator.value.id"
                    id="{{ 'phone' + operator.value.id }}"
                    maxLength="12"
                    dsPhoneMaskWithoutForm
                    (actualvalue)="changeNumber($event, operator.value.id)"
                    list="phone-numbers-modal"
                    type="tel"
                    inputmode="tel"
                    placeholder="Smartphone Number"
                  />
                  <datalist id="phone-numbers-modal">
                    @for (phone of phoneNumbers; track phone) {
                      <option [value]="phone">
                        {{ phone }}
                      </option>
                    }
                  </datalist>
                </td>
              }
            </tr>
          }
        </tbody>
      </table>
    }
    @if (duplicatePhoneError) {
      <p
        class="error-600-text caption"
        dsContent
        [contentPath]="'kydSmartphonePhh.duplicatePhoneErrorEnrollAll'"
      ></p>
    }
    <div class="column twelve margin-top-20">
      <div class="row flex items-center">
        <div class="column seven">
          <button
            ds-button
            class="-outline-white"
            (click)="closeModal.emit(modalId)"
            aria-label="Cancel"
          >
            Cancel
          </button>
        </div>
        <div class="column five pad-left-20">
          <button
            ds-button
            [disabled]="duplicatePhoneError || !allPhonesValid"
            class="-outline fill upperCaseBtn"
            (click)="save()"
            aria-label="Save"
          >
            Save
          </button>
        </div>
      </div>
    </div>
  </div>
</ds-modal>
